import HttpService from './baseHttp'


// 权限菜单管理
export const HttpMenuList = (data = {}, config) => HttpService.get('/api/v1/UcPermission/findAll', { params: data }, config)
// export const HttpAddMenu = (data, config) => HttpService.post('/api/jwt/ops/auth/ucSystem/findBySystemId', data, config)
export const HttpDelMenu = (data, config) => HttpService.post('/api/v1/UcPermission/del', data, config)
export const HttpGlobalDataList = (data = {}, config) => HttpService.get('api/v1/Context/globalDataList', { params: data }, config)
export const HttpUpdateMenu = (data, config) => HttpService.post('/api/v1/UcPermission/saveData', data, config)
export const HttpMenuDetail = (data, config) => HttpService.post('/api/v1/UcPermission/loadData', data, config)
export const HttpMenuSystem = (data = {}, config) => HttpService.get('/api/v1/UcSystem/findAllByContextId', { params: data }, config)
// 权限树位置移动
export const HttpMoveMenu = (data = {}, config) => HttpService.post('api/v1/UcPermission/move', data, config)




// 角色管理
export const HttpRoleList = (data, config) => HttpService.post('/api/v1/UcRole/findByPage', data, config)
export const HttpUpdateRole = (data, config) => HttpService.post('/api/v1/UcRole/saveData', data, config)
export const HttpDelRole = (data = {}, config) => HttpService.get('/api/v1/UcRole/del', { params: data }, config)
export const HttpRoleDetail = (data = {}, config) => HttpService.get('/api/v1/UcRole/loadData', { params: data }, config)
export const HttpConvertRoleAlias = (data = {}, config) => HttpService.get('/api/v1/UcRole/getCodeName', { params: data }, config)

// 用户管理
export const HttpUserList = (data, config) => HttpService.post('/api/v1/User/findByPage', data, config)
export const HttpUpdateUser = (data, config) => HttpService.post('/api/v1/User/saveData', data, config)
export const HttpDelUser = (data, config) => HttpService.post('/api/v1/User/del', data, config)
export const HttpSetUserStatus = (data, config) => HttpService.post('/api/v1/User/setStatus', data, config)
export const HttpUserDetail = (data = {}, config) => HttpService.get('/api/v1/User/loadData', { params: data }, config)
export const HttpUserBData = (data = {}, config) => HttpService.get('/api/v1/User/initData', { params: data }, config)
export const HttpUserValid = (data = {}) => HttpService.get('/api/v1/User/checkCodeExists', { params: data })
export const HttpUserTypeList = (data = {}) => HttpService.get('/api/v1/User/userContext', { params: data })


//组织管理
export const HttpSystemList = (data, config) => HttpService.post('/api/v1/Organization/findByPage', data, config)
export const HttpDelSystem = (data, config) => HttpService.post('/api/v1/Organization/del', data, config)
export const HttpSystemDetail = (data, config) => HttpService.get('/api/v1/Organization/loadData', { params: data }, config)
export const HttpUpdateSystem = (data) => HttpService.post('/api/v1/Organization/saveData', data)
export const HttpUpdateStstemStatus = (data) => HttpService.post('/api/v1/Organization/setStatus', data)
//组织类型
export const HttpOrgrTypeList = (data) => HttpService.get('/api/v1/Organization/userContext', { params: data })
//绑定关联组织
export const HttpOrgContextBindList = (data) => HttpService.get('/api/v1/Organization/findAllContextBind', { params: data })


//组织角色
export const HttpUpdateOrgrole = (data, config) => HttpService.post('/api/v1/UcOrgrole/saveData', data, config)
export const HttpOrgrolesAll = (data, ) => HttpService.get('/api/v1/UcOrgrole/findAllSelectableByContextId', { params: data })//查询所有组织角色 列表
export const HttpOrgroleDetail = (data, ) => HttpService.get('/api/v1/UcOrgrole/loadData', { params: data })//根据ID load出组织角色信息
export const HttpOrgroleList = (data, ) => HttpService.get('/api/v1/UcOrgrole/findByPage', { params: data })//组织角色列表分页展示
export const HttpDelOrgrole = (data, ) => HttpService.get('/api/v1/UcOrgrole/del', { params: data })//删除组织角色
export const HttpConvertOrgroleAlias = (data, ) => HttpService.get('/api/v1/UcOrgrole/getCodeName', { params: data })//根据显示名称生成角色标识
export const HttpOrgroleCode = (data, ) => HttpService.get('/api/v1/UcOrgrole/checkCodeExists', { params: data })//判断组织角色标识是否已存在
// export const HttpUpdateSystem = (data,) => HttpService.post('/api/v1/Organization/saveData', data, config)
// 获取允许的组织角色权限菜单
export const HttpOrgRolePerMenu = (data = {}) => HttpService.get('/api/v1/UcOrgrole/findAllSelectablePermissions', { params: data })
// 检查前缀代码
export const HttpCheckPcpfx = (data = {}) => HttpService.get('/api/v1/Organization/checkPcpfxExists', { params: data })
// 获取前缀代码
export const HttpGetPcpfx = (data = {}) => HttpService.get('/api/v1/Organization/genPcpfx', { params: data })
// 获取组织对应的选项
export const HttpGetOption = (data = {}) => HttpService.get('/api/v1/Organization/getContextOptionByName', { params: data });
// 更新组织配置
export const HttpUpdateOption = (data = {}) => HttpService.get('/api/v1/Organization/updateOrganizationSettings', { params: data });

// 多语言

// 按指定系统读取所有
export const HttpUclocaleFindAll = (data) => HttpService.get('/api/v1/BizLocaleMessage/findAllBySystemId', { params: data })
// 列表分页展示
export const HttpUclocaleList = (data) => HttpService.get('/api/v1/BizLocaleMessage/findByPage', { params: data })
// 按指定的langkey读取json结构化数据
export const HttpUclocaleStructRead = (data) => HttpService.get('/api/v1/BizLocaleMessage/getByLangKey', { params: data })
// 按指定json结构保存多行数据
export const HttpUclocaleStructUpdate = (data) => HttpService.post('/api/v1/BizLocaleMessage/dataSave', data, { headers: { "Content-Type": "application/json" } })
// 按指定json结构删除多行数据
export const HttpUclocaleStructRemove = (data, config) => HttpService.post('/api/v1/BizLocaleMessage/dataRemove', data, config)
// 按指定code/langkey删除关联的多行数据
export const HttpUclocaleCodeRemove = (data) => HttpService.get('/api/v1/BizLocaleMessage/delByCode', { params: data })
// 判断指定标识是否已存在
export const HttpUclocaleCheckExists = (data) => HttpService.get('/api/v1/BizLocaleMessage/checkCodeExists', { params: data })
// 删除指定id的单行数据
export const HttpUclocaleRowDel = (data) => HttpService.get('/api/v1/BizLocaleMessage/del', { params: data })
// 创建/更新单行数据
export const HttpUclocaleRowSave = (data, config) => HttpService.post('/api/v1/BizLocaleMessage/save', data, config)
// 根据code/langkey读取单行数据
export const HttpUclocaleRowGetByCode = (data) => HttpService.get('/api/v1/BizLocaleMessage/getByCode', { params: data })
// 根据id读取单行数据
export const HttpUclocaleRowGetById = (data) => HttpService.get('/api/v1/BizLocaleMessage/getById', { params: data })
// 根据ids列表读取多行数据
export const HttpUclocaleFindByIds = (data) => HttpService.get('/api/v1/BizLocaleMessage/findByIds', { params: data })



// 数据字典
// Dd is Digital dictionary
export const HttpDdRoles = (data = {}, config) => HttpService.get('/api/v1/UcRole/findAllByContextId', { params: data }, config)
export const HttpDdSystems = (data = {}) => HttpService.get('/api/v1/UcSystem/findAllByContextId', { params: data })
// 获取当前系统下所有权限列表
export const HttpPerMenu = (data = {}) => HttpService.get('/api/v1/UcRole/findAllSelectablePermissions', { params: data })
//查询组织ID下所有系统仓库(有权限访问的) 列表
export const HttpSysWarehouseList = (data = {}) => HttpService.get('/api/v1/Warehouse/findAllByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })


//数据报表权限
export const HttpBiReportSqlList = (data = {}) => HttpService.get('/api/v1/ReportSqlTemplate/findAllByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_BI })


//数据权限分组
// 数据权限分组列表分页展示
export const HttpAccessGroupList = (data = {}) => HttpService.get('/api/v1/UcAccessgroup/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 删除数据权限分组
export const HttpDelAccessGroup = (data = {}) => HttpService.get('/api/v1/UcAccessgroup/del', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 根据显示名称生成数据权限分组标识
export const HttpAccessGroupAlias = (data = {}) => HttpService.get('/api/v1/UcAccessgroup/getCodeName', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 根据ID load出数据权限分组信息
export const HttpAccessGroup = (data = {}) => HttpService.get('/api/v1/UcAccessgroup/loadData', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 创建/更新数据权限分组
export const HttpUpdateAccessGroup = (data = {}) => HttpService.post('/api/v1/UcAccessgroup/saveData', data, { baseURL: process.env.VUE_APP_APIURL_UC })

// 查询所有数据权限分组 列表
export const HttpAccessGroupAllList = (data = {}) => HttpService.get('/api/v1/UcAccessgroup/findAllByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 删除数据权限分组


//系统公告
// 系统公告列表分页展示
export const HttpUcAnnouncementList = (data = {}) => HttpService.get('/api/v1/UcAnnouncement/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 系统公告列表过滤条件展示
export const HttpUcAnnouncementFilter = (data = {}) => HttpService.get('/api/v1/UcAnnouncement/findByFilters', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 系统公告检查指定code是否存在
export const HttpUcAnnouncementCheckCodeExists = (data = {}) => HttpService.get('/api/v1/UcAnnouncement/checkCodeExists', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 设定指定指定id系统公告激活状态
export const HttpUcAnnouncementSetActive = (data = {}) => HttpService.get('/api/v1/UcAnnouncement/setActive', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 根据ID load出系统公告信息
export const HttpLoadUcAnnouncement = (data = {}) => HttpService.get('/api/v1/UcAnnouncement/loadData', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 创建/更新系统公告
export const HttpUpdateUcAnnouncement = (data = {}) => HttpService.post('/api/v1/UcAnnouncement/saveData', data, { baseURL: process.env.VUE_APP_APIURL_UC })
// 删除数据系统公告
export const HttpDelUcAnnouncement = (data = {}) => HttpService.get('/api/v1/UcAnnouncement/del', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 删除系统公告关联附件
export const HttpDelUcAnnouncementRelAttach = (data = {}) => HttpService.get('/api/v1/UcAnnouncement/delRelAttach', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })


// 附件规则
// 附件规则列表分页展示
export const HttpAttachmentRuleList = (data = {}) => HttpService.get('/api/v1/attachment/UcAttachRule/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 删除附件规则
export const HttpDelAttachmentRule = (data = {}) => HttpService.get('/api/v1/attachment/UcAttachRule/del', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 创建/更新附件规则
export const HttpUpdateAttachmentRule = (data = {}) => HttpService.post('/api/v1/attachment/UcAttachRule/saveData', data, { baseURL: process.env.VUE_APP_APIURL_UC })
//根据ID load出附件规则信息
export const HttpAttachmentRule = (data = {}) => HttpService.get('/api/v1/attachment/UcAttachRule/loadData', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })

//所有附件类型列表
export const HttpAllAttachmentType = (data = {}) => HttpService.get('/api/v1/BizAttach/types', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
//附件类型分页展示
export const HttpAttachmentTypeList = (data = {}) => HttpService.get('/api/v1/attachment/UcAttachType/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
//附件类型分页展示
export const HttpSaveAttachmentType = (data = {}) => HttpService.post('/api/v1/attachment/UcAttachType/saveData', data, { baseURL: process.env.VUE_APP_APIURL_UC })
//附件类型分页展示
export const HttpAttachmentType = (data = {}) => HttpService.get('/api/v1/attachment/UcAttachType/loadData', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })


//所有附件模块列表
export const HttpAllAttachmentModel = (data = {}) => HttpService.get('/api/v1/BizAttach/models', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
//附件模块
export const HttpAttachmentModelList = (data = {}) => HttpService.get('/api/v1/attachment/UcAttachModel/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
//创建/更新附件模块
export const HttpSaveAttachmentModel = (data = {}) => HttpService.post('/api/v1/attachment/UcAttachModel/saveData', data, { baseURL: process.env.VUE_APP_APIURL_UC })
//创建/更新附件模块
export const HttpAttachmentModel = (data = {}) => HttpService.get('/api/v1/attachment/UcAttachModel/loadData', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })



//附件上传列表
export const HttpAttachmentFileList = (data = {}) => HttpService.get('/api/v1/BizAttach/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
//上传附件
export const HttpUploadAttachmentFile = (data = {},config) => HttpService.post('/api/v1/BizAttach/uploadFile', data, {...config,baseURL: process.env.VUE_APP_APIURL_UC })
//删除附件
export const HttpDelAttachmentFile = (data = {}) => HttpService.get('/api/v1/BizAttach/del', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
//删除附件
export const HttpDelAttachmentFiles = (data = {}) => HttpService.get('/api/v1/BizAttach/del', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
//删除附件
export const HttpAttachmentFile = (data = {}) => HttpService.get('/api/v1/BizAttach/view', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 获取附件模型关联的附件类型
export const HttpAttachModelType = (data = {}) => HttpService.get('/api/v1/BizAttach/modelTypes', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 附件克隆
export const HttpAttachClone = (data = {}) => HttpService.post('/api/v1/attachment/UcAttachRule/cloneData', data, { baseURL: process.env.VUE_APP_APIURL_UC })

// 获取所有组织下供应商
export const HttpGetSupplierByContextId = (data = {}) => HttpService.get('/api/v2/Supplier/findAllByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 获取供应商分组的关联用户
export const HttpGetSupplierUser = (data = {}) => HttpService.get('/api/v1/UcAccessgroup/findAccessGroupAssignUsersByPage', { params: data })


//管理-注册申请
//分页读取申请条目
export const HttpFindByPage = (data = {}) => HttpService.get('/api/v1/UcRegistration/findByPage', { params: data })
//根据id读取申请条目
export const HttpLoadData = (data = {}) => HttpService.get('/api/v1/UcRegistration/loadData', { params: data })
//根据id删除申请条目
export const HttpDel = (data = {}) => HttpService.get('/api/v1/UcRegistration/del', { params: data })
//审批忽略
export const HttpBypass = (data = {}) => HttpService.get('/api/v1/UcRegistration/bypass', { params: data })
//审批通过
export const HttpAccept = (data = {}) => HttpService.get('/api/v1/UcRegistration/accept', { params: data })
//审批拒回
export const HttpDenied = (data = {}) => HttpService.get('/api/v1/UcRegistration/denied', { params: data })
//根据id检查属性标识是否存在
export const HttpCheckIdVectorExists = (data = {}) => HttpService.get('/api/v1/UcRegistration/checkIdVectorExistsById', { params: data })


// 用户管理新增可访问组织的展示条件
//

export const HttpUserDataAccess = (data = {}) => HttpService.get('/api/v1/Context/userDataAccess', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })



